import timePeriodList from './time-period-none';
import editor from '../AssignmentInitialDecision/editor';
import initialDecisionsNone from './initial-decision-none';
import manuscriptTypeNone from './manuscriptType';

export default [...timePeriodList, ...editor, ...initialDecisionsNone, ...manuscriptTypeNone];